module.exports = __webpack_public_path__ + "media/ברח.76fa1310.mp3";